
import React from 'react';
import { AppContext } from '../components/context/AppContext';
import Hero from '../components/hero/Hero';
import FlashSale from '../components/FlashSale';
import MostPopular from '../components/MostPopular';
import BestSelling from '../components/BestSelling';
import BigCart from '../components/BigCart';
import Hightlight from '../components/Highlight/Hightlight';
import Partners from '../components/Partners';
import About from '../components/about/';
import Footer from '../components/Footer';

const Home = () => {
  const { isOpenFlashSale } = React.useContext(AppContext);

  return (
    <div className='home'>
      <Hero />
      <Hightlight />
      { isOpenFlashSale && <FlashSale />}
      <MostPopular />
      <BestSelling />
      <BigCart />
      <Partners />
      <About />
      <Footer />
    </div>
  )
}

export default Home
